import {Component, OnInit} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {StripeAccountsService} from '../../../services/stripe-accounts.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'stripe-transactions-list',
    templateUrl: './stripe-transactions-list.component.html',
    styleUrls: ['./stripe-transactions-list.component.scss']
})
export class StripeTransactionsListComponent implements OnInit{
    allChecked = false;

    constructor(
        public urlService: UrlService,
        public stripeAccountsService: StripeAccountsService
    ) {}

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(() => this.allChecked = false);
        this.stripeAccountsService.onDetailedViewHide.subscribe(() => this.allChecked = false);
    }

    orderBy(orderBy: string, $event) {
        if (this.stripeAccountsService.data.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    toggleCheck(selectedItem): void {
        if(selectedItem.hasPayout) {
            toastr.warning('This transaction has already been payed out.');
            return;
        }
        selectedItem.checked = !selectedItem.checked;
        const itemIndex = this.stripeAccountsService.selectedItems.findIndex(si => selectedItem.id == si.id);
        if(!this.stripeAccountsService.showDetailedView)
            this.stripeAccountsService.getStripeBalance();

        if(itemIndex == -1)
            this.stripeAccountsService.selectedItems.push(selectedItem);
        else
            this.stripeAccountsService.selectedItems.splice(itemIndex, 1);

        this.stripeAccountsService.toggleDetailedView(selectedItem, true);
    }

    hasFilterOnTop() {
        return this.urlService.queryParams['hasPayout'] ||
               this.urlService.queryParams['periodStartDate'] || this.urlService.queryParams['periodEndDate'];
    }

    checkAll(event) {
        if(event) {
            this.stripeAccountsService.data.data.forEach(i => {
                i.checked = false;
                if(!i.hasPayout)
                    this.toggleCheck(i);
            });
        } else
            this.stripeAccountsService.toggleDetailedView(null, false);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/stripe-accounts/stripe-transactions-list/stripe-transactions-list.component.ts